// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outfit-font {
    font-family: "Outfit", sans-serif;
    font-optical-sizing: auto;
    font-style: normal;
}

.custom-header {
    font-family: Outfit;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 4px;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;

}`, "",{"version":3,"sources":["webpack://./src/layouts/movenow/index.css"],"names":[],"mappings":"AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;;AAE7B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');\n\n.outfit-font {\n    font-family: \"Outfit\", sans-serif;\n    font-optical-sizing: auto;\n    font-style: normal;\n}\n\n.custom-header {\n    font-family: Outfit;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 4px;\n    text-align: center;\n    vertical-align: middle;\n    text-transform: uppercase;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
